"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneTrustEnrichedAssessments = exports.OneTrustEnrichedAssessment = exports.OneTrustEnrichedAssessmentResponse = exports.OneTrustEnrichedUser = exports.OneTrustUserDetails = exports.OneTrustEnrichedAssessmentSection = exports.OneTrustEnrichedAssessmentQuestion = exports.OneTrustQuestionComments = exports.OneTrustQuestionComment = exports.OneTrustEnrichedRisks = exports.OneTrustEnrichedRisk = void 0;
const t = __importStar(require("io-ts"));
const endpoints_1 = require("./endpoints");
/** The default OneTrust Get Assessment risk response enriched with Get Risk response. */
exports.OneTrustEnrichedRisk = t.intersection([
    endpoints_1.OneTrustAssessmentQuestionRisk,
    endpoints_1.OneTrustGetRiskResponse,
]);
exports.OneTrustEnrichedRisks = t.union([
    t.array(exports.OneTrustEnrichedRisk),
    t.null,
]);
exports.OneTrustQuestionComment = t.type({
    comment: t.string,
    CreatedBy: t.string,
    CreateDate: t.string,
});
exports.OneTrustQuestionComments = t.array(exports.OneTrustQuestionComment);
/** The default OneTrust Get Assessment question response with enriched risks. */
exports.OneTrustEnrichedAssessmentQuestion = t.intersection([
    t.type({
        ...endpoints_1.OneTrustAssessmentQuestion.types[0].props,
        risks: exports.OneTrustEnrichedRisks,
    }),
    t.partial({
        ...endpoints_1.OneTrustAssessmentQuestion.types[1].props,
        comments: exports.OneTrustQuestionComments,
    }),
]);
/** The default OneTrust Get Assessment section response with enriched questions. */
exports.OneTrustEnrichedAssessmentSection = t.type({
    ...endpoints_1.OneTrustAssessmentSection.props,
    questions: t.array(exports.OneTrustEnrichedAssessmentQuestion),
});
/** The OneTrust Get User details about a user. */
exports.OneTrustUserDetails = t.type({
    active: endpoints_1.OneTrustGetUserResponse.props.active,
    userType: endpoints_1.OneTrustGetUserResponse.props.userType,
    emails: endpoints_1.OneTrustGetUserResponse.props.emails,
    title: endpoints_1.OneTrustGetUserResponse.props.title,
    givenName: t.union([t.string, t.null]),
    familyName: t.union([t.string, t.null]),
});
/** The default OneTrust Get Assessmenr user response enriched with Get User response */
exports.OneTrustEnrichedUser = t.type({
    ...endpoints_1.OneTrustAssessmentCreatedBy.props,
    ...exports.OneTrustUserDetails.props,
});
/** The default OneTrust Get Assessment response with enriched approvers, respondents, creator, and sections */
exports.OneTrustEnrichedAssessmentResponse = t.type({
    ...endpoints_1.OneTrustGetAssessmentResponse.props,
    approvers: t.array(t.type({
        ...endpoints_1.OneTrustApprover.props,
        approver: t.type({
            ...endpoints_1.OneTrustApprover.props.approver.props,
            ...exports.OneTrustUserDetails.props,
        }),
    })),
    respondents: t.array(t.intersection([
        t.type({
            ...endpoints_1.OneTrustGetAssessmentResponse.props.respondent.props,
        }),
        t.partial({
            ...exports.OneTrustUserDetails.props,
        }),
    ])),
    createdBy: exports.OneTrustEnrichedUser,
    sections: t.array(exports.OneTrustEnrichedAssessmentSection),
});
/** The default OneTrust Get List of Assessments response with enriched assessment */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { status, ...OneTrustAssessmentWithoutStatus } = endpoints_1.OneTrustAssessment.props;
exports.OneTrustEnrichedAssessment = t.intersection([
    t.type(OneTrustAssessmentWithoutStatus),
    exports.OneTrustEnrichedAssessmentResponse,
]);
exports.OneTrustEnrichedAssessments = t.array(exports.OneTrustEnrichedAssessment);
//# sourceMappingURL=enrichedCodecs.js.map